import React, { memo } from 'react';
import { numberWithCommas } from '@app/utils';
import { taggingClickViewMoreEntitlement } from '@app/utils/gtmTracking';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
const {
  breakpoints
} = theme;
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1sgdazv"
});
const LoadMore = ({
  link,
  label = '',
  eventName,
  action = 'click_newest_jobs',
  total,
  handleClickLoadmore,
  isEntitlement,
  isUrgentJobAd
}) => {
  if (isEntitlement && total <= 10) return null;
  let title = label;
  if (!label) {
    if (isEntitlement || isUrgentJobAd) {
      title = 'Xem thêm các việc làm  khác';
    } else if (total === 0 || eventName === 'job_personalize_ads') {
      title = 'Xem thêm';
    } else {
      title = `Xem thêm ${numberWithCommas(total)} việc làm khác`;
    }
  }
  const onClick = () => {
    if (handleClickLoadmore) {
      if (eventName === 'job_personalize_ads') {
        action = 'click_see_more';
      }
      if (isEntitlement) taggingClickViewMoreEntitlement();else handleClickLoadmore(title, eventName, action);
    }
    setTimeout(() => {
      window.location.href = link;
    }, 500);
  };
  return <Wrapper>
      <button type="button" onClick={() => onClick()}>
        {title}
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
          <g fill="none" fillRule="evenodd">
            <path stroke="#38699F" strokeLinecap="round" strokeWidth="1.5" d="M1.125 3L6.75 8 1.125 13" transform="translate(1 1)" />
            <path stroke="#FFF" strokeWidth=".1" d="M0 0H9V16H0z" opacity=".01" transform="translate(1 1)" />
          </g>
        </svg>
      </button>
    </Wrapper>;
};
LoadMore.defaultProps = {};
LoadMore.propTypes = {};
export default memo(LoadMore);

require("../../../../.linaria-cache/src/components/GridAds/LoadMore/LoadMore.linaria.module.css");